import * as AdminApi from './generated-admin-api';
import * as NotifiesApi from './generated-notifies-api';
import * as UserApi from './generated-api';
import {pick} from 'lodash';
import {deduplicateGetRequests} from '../../api/get-request-deduplicator';

export * from './generated-api';

const config = {
  baseURL: process.env.REACT_APP_API_URL_V2 || 'http://localhost:3000/api/v2',
  headers: {'Content-Type': 'application/json'},
  withCredentials: true,
} as const;

const configPublic = {
  baseURL: '/api/public/v2',
  headers: {'Content-Type': 'application/json'},
  withCredentials: true,
} as const;

export const api = new UserApi.Api(config);
const publicApiClient = new UserApi.Api(configPublic);
deduplicateGetRequests(api.instance);
deduplicateGetRequests(publicApiClient.instance);
export const publicApi = {
  companies: pick(publicApiClient.companies, 'postCompaniesCreateForDemo'),
  captcha: publicApiClient.captcha,
};
export const adminApi = new AdminApi.Api(config);
export const notifiesApi = new NotifiesApi.Api(config);

deduplicateGetRequests(adminApi.instance);
deduplicateGetRequests(notifiesApi.instance);
